<template>
  <a id="botaoJuntar" @click="$emit('juntarDocumento')" class="juntar__botao-link">
    <i class="fab fa-telegram-plane" aria-hidden="true"/>
    Juntar
  </a>
</template>

<script>
export default {
    name: 'BotaoJuntar'
}
</script>

<style scoped lang="stylus">
  .juntar
    color #888
    &__botao-link
      background-color #fff
      color #888
      padding 5px 10px 7px 5px
      min-width 50px
      border 0.1px solid #CACFD2

      i
        color #777 !important
        font-size 13px
        top 0

      &:hover, &:active, &:focus
        background-color #e4e4e4
        padding 3px 8px 5px 3px
        border 3px solid #CACFD2
        border-radius 4px

</style>
